<template>
  <div class="card">
    <div class="card-body">
      <div class="row">
        <div class="search-row mb-3">
          <div class="form-group search-box item mb-0">
            <label for="paginate" class="mb-0">Search</label>
            <input
              v-model="q"
              type="search"
              class="form-control"
              placeholder="Search ..."
              @keyup.enter="fnSearch()"
            />
          </div>

          <div class="status-box item">
            <label for="paginate" class="mb-0">Status</label>
            <select
              v-model="selectedStatus"
              class="form-control sits_select"
              @change="fnSearch()"
            >
              <option value="">All Status</option>
              <option value="0">In-active</option>
              <option value="1">Active</option>
            </select>
          </div>
          <div class="item">
            <button class="btn btn-sm btn-primary mt-4" @click="fnSearch()">
              Search
            </button>
          </div>
          <div class="item">
            <button class="btn btn-sm btn-primary mt-4" @click="fnClear()">
              Clear
            </button>
          </div>
        </div>
        <div class="table-responsive table-sm">
          <table
            class="
              v-datatable-light
              table table-bordered table-hover table-striped table-center
            "
          >
            <thead>
              <tr>
                <th class="header-item">
                  <input
                    type="checkbox"
                    v-model="selectedAll"
                    @change="fnSelectedAll"
                  />
                </th>
                <th class="header-item">
                  <a href="#" @click.prevent="fnChangeSort('id')">Id</a>
                  <span v-if="sort_direction == 'desc' && sort_field == 'id'"
                    >&uarr;</span
                  >
                  <span v-if="sort_direction == 'asc' && sort_field == 'id'"
                    >&darr;</span
                  >
                </th>
                <th class="header-item">
                  <a href="#" @click.prevent="fnChangeSort('legal_name')"
                    >Legal name</a
                  >
                  <span
                    v-if="
                      sort_direction == 'desc' && sort_field == 'legal_name'
                    "
                    >&uarr;</span
                  >
                  <span
                    v-if="sort_direction == 'asc' && sort_field == 'legal_name'"
                    >&darr;</span
                  >
                </th>
                <th class="header-item">
                  <a href="#" @click.prevent="fnChangeSort('trading_as_name')"
                    >Trading name</a
                  >
                  <span
                    v-if="
                      sort_direction == 'desc' &&
                      sort_field == 'trading_as_name'
                    "
                    >&uarr;</span
                  >
                  <span
                    v-if="
                      sort_direction == 'asc' && sort_field == 'trading_as_name'
                    "
                    >&darr;</span
                  >
                </th>
                <th class="header-item">FBT Status</th>
                <th class="header-item">Phone</th>
                <th class="header-item">Acc. Con. first name</th>
                <th class="header-item">Acc. Con. email</th>
                <th class="header-item">Pay. Con. first name</th>
                <th class="header-item">Pay. Con. email</th>
                <th class="header-item">EOY Email</th>
                <th class="header-item">Number Emp.</th>
                <th class="header-item v-th-center">
                  <a href="#" @click.prevent="fnChangeSort('status')">Status</a>
                  <span
                    v-if="sort_direction == 'desc' && sort_field == 'status'"
                    >&uarr;</span
                  >
                  <span v-if="sort_direction == 'asc' && sort_field == 'status'"
                    >&darr;</span
                  >
                </th>
              </tr>
            </thead>
            <tbody>
              <template v-for="(row, index) in getEmployerPaginateData.data">
                <tr :key="(row, index)">
                  <td>
                    <!-- <input
                      type="checkbox"
                      :checked="selected.includes(row.id)"
                      @click="fnSelected(row.id)"
                    /> -->
                    <input
                      type="checkbox"
                      v-model="selected"
                      :value="row.id"
                      @click="fnSelected(row.id)"
                    />
                  </td>
                  <td>{{ row.id }}</td>
                  <td>{{ row.legal_name }}</td>
                  <td>
                    {{ row.trading_as_name }}
                  </td>
                  <td>
                    {{ row.fbt_status }}
                  </td>
                  <td>{{ row.main_phone }}</td>
                  <td>
                    {{ row.acc_contact_first_name }}
                  </td>
                  <td>
                    {{ row.acc_contact_email }}
                  </td>
                  <td>
                    {{ row.pay_contact_first_name }}
                  </td>
                  <td>
                    {{ row.pay_contact_email }}
                  </td>

                  <td>
                    {{ row.eoy_fbt_reporting_email }}
                  </td>
                  <td>
                    {{ row.number_of_employee }}
                  </td>

                  <td class="v-td-center">
                    <div v-if="row.status == 0">
                      <span class="badge bdg-draft">In-active</span>
                    </div>
                    <div v-if="row.status == 1">
                      <span class="badge bdg-new">Active</span>
                    </div>
                  </td>
                </tr>
              </template>

              <!-- Pagination -->
              <tr>
                <td colspan="15">
                  <div class="sits-pagination-row">
                    <div class="items-per-page">
                      <div class="pr-2">
                        <p class="mb-0">Items per page</p>
                      </div>
                      <div class="pr-5">
                        <select
                          v-model="recordsPerPage"
                          class="form-control sits_select"
                          @change="fnRecordsPerPage()"
                        >
                          <option value="10">10</option>
                          <option value="15">15</option>
                          <option value="20">20</option>
                          <option value="30">30</option>
                          <option value="40">40</option>
                          <option value="50">50</option>
                          <option value="100">100</option>
                        </select>
                      </div>
                    </div>

                    <div>
                      <pagination
                        :limit="5"
                        :data="getEmployerPaginateData"
                        @pagination-change-page="fnGetQuoteList"
                      ></pagination>
                    </div>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import pagination from 'laravel-vue-pagination'
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'EMStep1',
  components: {
    pagination
  },
  data() {
    return {
      selected: [],
      selectedCurrentPage: [],
      selectedAll: false,
      quoteList: {},
      recordsPerPage: 3,
      page: 1,
      q: '',
      selectedStatus: '',
      sort_direction: 'asc',
      sort_field: 'id',
      paginate: {
        page: 1,
        recordsPerPage: 3,
        q: '',
        selectedStatus: '',
        sort_direction: 'asc',
        sort_field: 'id'
      }
    }
  },
  computed: {
    ...mapGetters([
      'getEmployerPaginateData',
      'getEmployerPaginate',
      'getEMWizardData'
    ])
  },
  methods: {
    ...mapActions(['fetchEmployerPaginate', 'fetchEMWizardData']),

    fnSelectedAll: function () {
      let employerPaginateData = this.getEmployerPaginateData.data

      if (this.selectedAll) {
        employerPaginateData.map((row) => {
          this.selected.push(row.id)
        })
      }
    },
    fnSelected: function (id) {
      this.selectedAll = false
      const index = this.selected.indexOf(id)

      if (index > -1) {
        this.selected.splice(index, 1)
      } else {
        this.selected.push(id)
      }
    },
    fnGetQuoteList: async function (page = 1) {
      let obj1 = this.paginate
      let obj2 = {
        page: page,
        recordsPerPage: this.recordsPerPage,
        q: this.q,
        selectedStatus: this.selectedStatus,
        sort_direction: this.sort_direction,
        sort_field: this.sort_field
      }
      let objNew = { ...obj1, ...obj2 }
      await this.fetchEmployerPaginate(objNew)
      this.fnSelectedAll()

      if (this.selectedAll) {
        this.selectedCurrentPage
        let oldArray = Array(...this.selected)
        let newArray = this.fnGetSelectedAllId()
        let arr = [...oldArray, ...newArray]

        this.selected = [...new Set(arr)]

        console.log(this.selected)
      }
    },

    fnRecordsPerPage() {
      let obj1 = this.paginate
      let obj2 = {
        page: this.page,
        recordsPerPage: this.recordsPerPage,
        q: this.q,
        selectedStatus: this.selectedStatus,
        sort_direction: this.sort_direction,
        sort_field: this.sort_field
      }
      let objNew = { ...obj1, ...obj2 }

      this.fetchEmployerPaginate(objNew)
    },

    fnSearch() {
      let obj1 = this.paginate
      let obj2 = {
        page: this.page,
        recordsPerPage: this.recordsPerPage,
        q: this.q,
        selectedStatus: this.selectedStatus,
        sort_direction: this.sort_direction,
        sort_field: this.sort_field
      }
      let objNew = { ...obj1, ...obj2 }
      this.fetchEmployerPaginate(objNew)
    },

    fnChangeSort(field) {
      if (this.sort_field == field) {
        this.sort_direction = this.sort_direction == 'asc' ? 'desc' : 'asc'
      } else {
        this.sort_field = field
      }
      let obj1 = this.paginate
      let obj2 = {
        page: this.page,
        recordsPerPage: this.recordsPerPage,
        q: this.q,
        selectedStatus: this.selectedStatus,
        sort_direction: this.sort_direction,
        sort_field: this.sort_field
      }
      let objNew = { ...obj1, ...obj2 }
      this.fetchEmployerPaginate(objNew)
    },

    fnClear() {
      this.q = ''
      this.selectedStatus = ''
      let obj1 = this.paginate
      let obj2 = {
        page: 1,
        recordsPerPage: 3,
        q: '',
        selectedStatus: '',
        sort_direction: 'asc',
        sort_field: 'id'
      }
      let objNew = { ...obj1, ...obj2 }
      this.fetchEmployerPaginate(objNew)
    },

    fnGetSelectedAllId() {
      let employerPaginateData = this.getEmployerPaginateData.data
      return employerPaginateData.map((item) => item.id)
    }
  },

  mounted() {
    let obj1 = this.paginate
    let obj2 = {
      page: 1,
      recordsPerPage: 3,
      q: '',
      selectedStatus: '',
      sort_direction: 'asc',
      sort_field: 'id'
    }
    let objNew = { ...obj1, ...obj2 }
    this.fetchEmployerPaginate(objNew)
  },
  watch: {
    selected(newValue) {
      let obj = { selected: [...new Set(newValue)] }
      this.fetchEMWizardData({ ...this.getEMWizardData, ...obj })

      // this.fetchEMWizardData({
      //   selected: [...new Set(newValue)],
      //   selectedAll: this.selectedAll,
      //   docId: this.getEMWizardData?.docId
      // })
    },
    selectedAll(newValue) {
      let obj = { selectedAll: newValue }
      this.fetchEMWizardData({ ...this.getEMWizardData, ...obj })

      // this.fetchEMWizardData({
      //   selected: [...new Set(this.selected)],
      //   selectedAll: newValue,
      //   docId: this.getEMWizardData?.docId
      // })
    }
  }
}
</script>

<style lang="scss" scoped>
.search-row {
  display: flex;
  // justify-content: space-between;
  gap: 20px;
  .search-box {
    width: 450px;
  }
  .status-box {
    width: 250px;
  }

  .item {
    align-self: center;
  }
}

.sits-pagination-row {
  display: flex;
  gap: 10px;
  align-items: baseline;
  padding-top: 5px;
  padding-bottom: 5px;

  .items-per-page {
    display: flex;
    align-items: baseline;
  }

  ul.pagination {
    margin-bottom: 0;
  }

  .page-item.active .page-link {
    z-index: 3;
    color: #fff;
    background-color: red;
    border-color: red;
  }
}
</style>
